"use client";

import Link from "next/link";
import { slugifyUser } from "~/utils/string";
import { cn } from "~/utils/fontsConfig";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "../shadcn/Tooltip";
import UserImage from "../users-components/UserImage";
import { If } from "../Conditional";
import { UserAvatar } from "~/components/v4/shadcn/UserAvatar";

interface CommunityHeadsProps {
    users: {
        id?: string;
        name: string | null;
        image: string | null;
        slug: string | null;
    }[];
    showMax?: number;
    iconSize?: number;
    spaceIcons?: boolean;
    suffixCounter?: number;
    suffixClassName?: string;
    revealPII?: boolean;
    profileLink?: boolean;
}

const CommunityHeads = ({
    users,
    showMax = 5,
    iconSize = 27,
    spaceIcons = true,
    suffixCounter,
    suffixClassName,
    revealPII,
    profileLink,
}: CommunityHeadsProps) => {
    const withOutLine = spaceIcons
        ? ""
        : "outline outline-1 -outline-offset-1 outline-[#373A41AF]";

    let counter = suffixCounter?.toString();

    if (suffixCounter && suffixCounter > 1000) {
        counter = `${Math.round(suffixCounter / 1000)}k`;
    }

    return (
        <div className="mt-3 flex select-none gap-3">
            <div
                className={cn(
                    "flex flex-row",
                    spaceIcons ? "gap-2" : "-space-x-4",
                )}
            >
                {users
                    .sort(
                        (a, b) =>
                            (!a.image ? 1 : -Infinity) -
                            (!b.image ? 1 : -Infinity),
                    )
                    .slice(0, showMax)
                    .map((user, index) => (
                        <div
                            key={index}
                            style={{
                                zIndex: index < 10 ? 20 - index : 10,
                            }}
                            className="relative"
                        >
                            {user.name && revealPII !== false ? (
                                <TooltipProvider delayDuration={0}>
                                    <Tooltip>
                                        <TooltipTrigger>
                                            <Link
                                                className=""
                                                href={`/profile/${slugifyUser(
                                                    user,
                                                )}`}
                                            >
                                                <UserAvatar
                                                    user={user}
                                                    className="h-11 w-11"
                                                />
                                            </Link>
                                        </TooltipTrigger>
                                        <TooltipContent sideOffset={-180}>
                                            <p>{user.name ?? ""}</p>
                                        </TooltipContent>
                                    </Tooltip>
                                </TooltipProvider>
                            ) : (
                                <div>
                                    <If condition={profileLink === true}>
                                        <Link
                                            href={`/profile/${slugifyUser({
                                                name: user.name,
                                                id: user.id,
                                                slug: user.slug,
                                            })}`}
                                            target="_blank"
                                        >
                                            <UserAvatar
                                                user={user}
                                                className="h-11 w-11"
                                            />
                                        </Link>
                                    </If>
                                    <If condition={!profileLink}>
                                        <UserAvatar
                                            user={user}
                                            className="h-11 w-11"
                                        />
                                    </If>
                                </div>
                            )}
                        </div>
                    ))}
            </div>
            {!!suffixCounter && counter && (
                <div
                    className={cn(
                        "flex items-center justify-center bg-transparent text-[24px] md:text-[30px]",
                        suffixClassName,
                    )}
                >
                    +{counter}
                </div>
            )}
        </div>
    );
};

export default CommunityHeads;
